(ns io.daskul.webapp.api.client
  "HTTP client utilities for API requests.

   Provides configurable API base URL and auth header.")

(def ^:dynamic *api-url*
  "Base URL for API - can be configured via configure! in core.cljs"
  "/api")

(defn auth-header
  "Get Authorization header with JWT token from localStorage.

   Returns map with Authorization header if token exists, empty map otherwise."
  []
  (when-let [token (.getItem js/localStorage "auth-token")]
    {"Authorization" (str "Bearer " token)}))

(def api-url *api-url*)
